export interface NotificationCenterResource {
    uuid: string
    action: string
    category: string
    tags: string[]
    currentUserName: string
}

export interface NotificationCenterLog {
    uuid: string
    action: string
    category: string
    tags: string[]
    currentUserName: string
}

// Update this enum from /api/v3/event-logs/categories if needed
export enum NotificationCenterCategory {
    ABSENCE = 'verzuim',
    AGNOSTIC = 'agnostic',
    CUSTOM = 'custom',
    DATA_UPDATE = 'data-update',
    EMAIL = 'email',
    ENTITY = 'entity',
    LEAVE_OF_ABSENCE = 'verlof',
    SHIFT = 'dienst',
    SHIFT_PLANNING = 'dienstplanning',
    SHIFT_PLANNING_REMOVAL = 'dienstplanningremoval',
    TRACKS = 'tracks',
    UNKNOWN = 'unknown',
    USER = 'gebruiker',
}

// Update this enum from /api/v3/event-logs/actions if needed
export enum NotificationCenterAction {
    AGNOSTIC = 'agnostic',
    CREATED = 'created',
    DELETED = 'deleted',
    GENERATE = 'generate',
    NOTIFICATION = 'notification',
    UNKNOWN = 'unknown',
    UPDATED = 'updated',
}

// Update this enum from /api/v3/event-logs/tags if needed
export enum NotificationCenterActionCategory {
    CONCEPT_SHIFT_CREATED = 'concept-dienst-aangemaakt',
    CONCEPT_SHIFTS_BATCH_PUBLISHED = 'diensten-publiceren',
    SHIFT_CREATED = 'dienst-aangemaakt',
    SHIFT_DELETED = 'dienst-verwijderd',
    SHIFT_UPDATED = 'dienst-gewijzigd',
    SHIFT_PLANNING_CREATED = 'dienstplanning-aangemaakt',
    SHIFT_PLANNING_REGISTERED = 'dienstplanning-aangemeld',
    SHIFT_PLANNING_REGISTRATION_ACCEPTED = 'dienstplanning-aanmelding-geaccepteerd',
    SHIFT_PLANNING_REGISTRATION_DELETED = 'dienstplanning-aanmelding-verwijderd',
    SHIFT_PLANNING_UPDATED = 'dienstplanning-gewijzigd',
    BATCH_INSERT = 'batch-insert',
    UNKNOWN = 'unknown',
}

export enum NotificationCenterHeaderName {
    X_EVENT = 'x-event',
}
